<mat-form-field class="example-chip-list">
  <mat-chip-grid #chipList [disabled]="disabled">
    <mat-chip-row
      *ngFor="let item of selectedItems"
      [editable]="true"
      [removable]="removable"
      (removed)="remove(item)"
      >
      {{ ItemDescriptionSel(item) }}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip-row>
    <input
      #textInput
      [placeholder]="placeholder"
      [formControl]="itemCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (blur)="addOnBlur($event)"
      matChipInputAddOnBlur="false"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option
      *ngFor="let item of filteredItems | async"
      [value]="ItemValue(item)"
    >
      {{ ItemDescription(item) }}
    </mat-option>
  </mat-autocomplete>
  <mat-error>Verifique esse campo</mat-error>
</mat-form-field>
